import { customElement, property, state } from "lit/decorators.js";
import { BaseComponent } from "../../base-component/base-component";
import { html, nothing, TemplateResult } from "lit";
import "../../off-canvas/off-canvas";
import "../components/wish-list-create";
import { WISH_LIST_OFF_CANVAS_IDS } from "../interfaces/wish-list-off-canvas.interface";
import { OffCanvasConfigs } from "../../off-canvas/interfaces/off-canvas.interface";
import "../components/wish-list-delete";
import "../components/wish-list-download";
import { WishList } from "../interfaces/wish-list-items.interface";
import store from "../../../store/store";
import { connect } from "pwa-helpers";
import { StoreState } from "../../../store/store.interface";
import { getOffCanvasData } from "../../off-canvas/store/off-canvas.selector";

@customElement('mhecomm-wish-list-download-off-canvas')
export class WishListDownloadOffCanvas extends connect(store)(BaseComponent) {

  @property()
  offCanvasTitle = 'Save List';

  @state()
  wishlist?: WishList;

  stateChanged(state: StoreState): void {
    this.wishlist = getOffCanvasData(state)?.[WISH_LIST_OFF_CANVAS_IDS.DOWNLOAD_WISH_LIST_ITEMS];
  }

  /**
   * Displays the off-canvas for creating a wishlist.
   */
  renderComp(): TemplateResult | typeof nothing {
    return html`
      <mhecomm-off-canvas .offCanvasConfigs="${this.getOffCanvasConfigs()}">
        <div slot=${WISH_LIST_OFF_CANVAS_IDS.DOWNLOAD_WISH_LIST_ITEMS + "-off-canvas-body"}>
          <mhecomm-download-wish-list 
            offCanvasId="${WISH_LIST_OFF_CANVAS_IDS.DOWNLOAD_WISH_LIST_ITEMS}"
            .wishList=${this.wishlist}
          ></mhecomm-download-wish-list>
        </div>
      </mhecomm-off-canvas>
    `
  }

  /**
   * Returns the off-canvas configs for the component.
   *
   * This configuration is updated based on the states.
   */
  private getOffCanvasConfigs(): OffCanvasConfigs {
    return {
      [WISH_LIST_OFF_CANVAS_IDS.DOWNLOAD_WISH_LIST_ITEMS]: {
        id: WISH_LIST_OFF_CANVAS_IDS.DOWNLOAD_WISH_LIST_ITEMS,
        title: html`<h5 class="mb-0">${this.offCanvasTitle}</h5>`,
        closeTriggerId: 'cancelWishlistDownloadBtn',
      }
    }
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-wish-list-download-off-canvas': WishListDownloadOffCanvas;
  }
}